import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ZKeyDetectorService {
  private zPressCount = 0;
  private lastZPressTime = 0;
  private readonly timeWindow = 2000; // 2 seconds
  private readonly requiredPresses = 3;

  private toggleVisibleSubject = new BehaviorSubject<boolean>(false);
  public toggleVisible$ = this.toggleVisibleSubject.asObservable();

  private gamingModeSubject = new BehaviorSubject<boolean>(false);
  public gamingMode$ = this.gamingModeSubject.asObservable();

  constructor() {
    this.setupKeyListener();
  }

  private setupKeyListener(): void {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'z' && !event.ctrlKey && !event.altKey && !event.metaKey) {
        this.handleZKeyPress();
      }
    });
  }

  private handleZKeyPress(): void {
    const currentTime = Date.now();

    if (currentTime - this.lastZPressTime > this.timeWindow) {
      this.zPressCount = 1;
    } else {
      this.zPressCount++;
    }

    this.lastZPressTime = currentTime;

    if (this.zPressCount === this.requiredPresses) {
      this.toggleVisibility();
      this.zPressCount = 0;
    }
  }

  private toggleVisibility(): void {
    const currentValue = this.toggleVisibleSubject.value;
    this.toggleVisibleSubject.next(!currentValue);

    // If hiding the toggle, automatically return to normal mode
    if (currentValue) {
      this.gamingModeSubject.next(false);
    }
  }

  public isToggleVisible(): boolean {
    return this.toggleVisibleSubject.value;
  }

  public toggleGamingMode(): void {
    const currentValue = this.gamingModeSubject.value;
    this.gamingModeSubject.next(!currentValue);
  }

  public isGamingMode(): boolean {
    return this.gamingModeSubject.value;
  }

  public setGamingMode(isGaming: boolean): void {
    this.gamingModeSubject.next(isGaming);
  }
}